/* tslint:disable */
/* eslint-disable */
/**
 * Registration App Tier Micro Service APIs
 * Registration App Tier Micro Service APIs
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AutoRenewSubmitDetail } from './AutoRenewSubmitDetail';
import {
    AutoRenewSubmitDetailFromJSON,
    AutoRenewSubmitDetailFromJSONTyped,
    AutoRenewSubmitDetailToJSON,
} from './AutoRenewSubmitDetail';
import type { AutoRenewalVerificationStatus } from './AutoRenewalVerificationStatus';
import {
    AutoRenewalVerificationStatusFromJSON,
    AutoRenewalVerificationStatusFromJSONTyped,
    AutoRenewalVerificationStatusToJSON,
} from './AutoRenewalVerificationStatus';
import type { Citizenship } from './Citizenship';
import {
    CitizenshipFromJSON,
    CitizenshipFromJSONTyped,
    CitizenshipToJSON,
} from './Citizenship';
import type { CoAppDocument } from './CoAppDocument';
import {
    CoAppDocumentFromJSON,
    CoAppDocumentFromJSONTyped,
    CoAppDocumentToJSON,
} from './CoAppDocument';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
} from './Contact';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
} from './Gender';
import type { InternationalSponsor } from './InternationalSponsor';
import {
    InternationalSponsorFromJSON,
    InternationalSponsorFromJSONTyped,
    InternationalSponsorToJSON,
} from './InternationalSponsor';
import type { MaritalStatusCd } from './MaritalStatusCd';
import {
    MaritalStatusCdFromJSON,
    MaritalStatusCdFromJSONTyped,
    MaritalStatusCdToJSON,
} from './MaritalStatusCd';
import type { MinorDocument } from './MinorDocument';
import {
    MinorDocumentFromJSON,
    MinorDocumentFromJSONTyped,
    MinorDocumentToJSON,
} from './MinorDocument';
import type { PersonalId } from './PersonalId';
import {
    PersonalIdFromJSON,
    PersonalIdFromJSONTyped,
    PersonalIdToJSON,
} from './PersonalId';
import type { SignInIdFlow } from './SignInIdFlow';
import {
    SignInIdFlowFromJSON,
    SignInIdFlowFromJSONTyped,
    SignInIdFlowToJSON,
} from './SignInIdFlow';
import type { Signature } from './Signature';
import {
    SignatureFromJSON,
    SignatureFromJSONTyped,
    SignatureToJSON,
} from './Signature';
import type { TaxId } from './TaxId';
import {
    TaxIdFromJSON,
    TaxIdFromJSONTyped,
    TaxIdToJSON,
} from './TaxId';
import type { UsernameContactType } from './UsernameContactType';
import {
    UsernameContactTypeFromJSON,
    UsernameContactTypeFromJSONTyped,
    UsernameContactTypeToJSON,
} from './UsernameContactType';

/**
 * 
 * @export
 * @interface RegistrationPatchRequest
 */
export interface RegistrationPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    familyName?: string;
    /**
     * 
     * @type {number}
     * @memberof RegistrationPatchRequest
     */
    sponsor?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationPatchRequest
     */
    doNotKnowSponsor?: boolean;
    /**
     * 
     * @type {InternationalSponsor}
     * @memberof RegistrationPatchRequest
     */
    internationalSponsor?: InternationalSponsor;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationPatchRequest
     */
    multipleBusinessFlag?: boolean;
    /**
     * 
     * @type {object}
     * @memberof RegistrationPatchRequest
     */
    extensions?: object;
    /**
     * 
     * @type {number}
     * @memberof RegistrationPatchRequest
     */
    partyId?: number;
    /**
     * 
     * @type {PersonalId}
     * @memberof RegistrationPatchRequest
     */
    personalId?: PersonalId;
    /**
     * 
     * @type {Array<PersonalId>}
     * @memberof RegistrationPatchRequest
     */
    personalIdList?: Array<PersonalId>;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    taxRegime?: string;
    /**
     * 
     * @type {PersonalId}
     * @memberof RegistrationPatchRequest
     */
    spousePersonalId?: PersonalId;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegistrationPatchRequest
     */
    consentAccepted?: Array<RegistrationPatchRequestConsentAcceptedEnum>;
    /**
     * 
     * @type {TaxId}
     * @memberof RegistrationPatchRequest
     */
    taxId?: TaxId;
    /**
     * 
     * @type {Contact}
     * @memberof RegistrationPatchRequest
     */
    billingAddress?: Contact;
    /**
     * birthday
     * @type {Date}
     * @memberof RegistrationPatchRequest
     */
    birthDate?: Date;
    /**
     * 
     * @type {Gender}
     * @memberof RegistrationPatchRequest
     */
    gender?: Gender;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationPatchRequest
     */
    isMinor?: boolean;
    /**
     * 
     * @type {Array<MinorDocument>}
     * @memberof RegistrationPatchRequest
     */
    minorDocuments?: Array<MinorDocument>;
    /**
     * 
     * @type {Array<CoAppDocument>}
     * @memberof RegistrationPatchRequest
     */
    coAppDocuments?: Array<CoAppDocument>;
    /**
     * 
     * @type {Signature}
     * @memberof RegistrationPatchRequest
     */
    signature?: Signature;
    /**
     * 
     * @type {Citizenship}
     * @memberof RegistrationPatchRequest
     */
    citizenship?: Citizenship;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    citizenshipCountry?: string;
    /**
     * 
     * @type {Citizenship}
     * @memberof RegistrationPatchRequest
     */
    spouseCitizenship?: Citizenship;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    spouseCitizenshipCountry?: string;
    /**
     * 
     * @type {MaritalStatusCd}
     * @memberof RegistrationPatchRequest
     */
    maritalStatus?: MaritalStatusCd;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof RegistrationPatchRequest
     */
    accountNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    verifyPersonalId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    fullUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    invitationLink?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    challengeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    prePrintedKitId?: string;
    /**
     * 
     * @type {number}
     * @memberof RegistrationPatchRequest
     */
    reservedAccountNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationPatchRequest
     */
    orderRequired?: boolean;
    /**
     * 
     * @type {SignInIdFlow}
     * @memberof RegistrationPatchRequest
     */
    signInIdFlow?: SignInIdFlow;
    /**
     * 
     * @type {UsernameContactType}
     * @memberof RegistrationPatchRequest
     */
    usernameContactType?: UsernameContactType;
    /**
     * 
     * @type {AutoRenewalVerificationStatus}
     * @memberof RegistrationPatchRequest
     */
    autoRenewalVerificationStatus?: AutoRenewalVerificationStatus;
    /**
     * 
     * @type {Date}
     * @memberof RegistrationPatchRequest
     */
    autoRenewalPaymentVerificationSubmitDateTime?: Date;
    /**
     * 
     * @type {AutoRenewSubmitDetail}
     * @memberof RegistrationPatchRequest
     */
    autoRenewDetails?: AutoRenewSubmitDetail;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    employeeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    interimPhone?: string;
    /**
     * 
     * @type {number}
     * @memberof RegistrationPatchRequest
     */
    registeredAccountNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    otpRequestId?: string;
    /**
     * 
     * @type {number}
     * @memberof RegistrationPatchRequest
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof RegistrationPatchRequest
     */
    identityJWT?: string;
}


/**
 * @export
 */
export const RegistrationPatchRequestConsentAcceptedEnum = {
    Terms: 'TERMS',
    PersonalData: 'PERSONAL_DATA',
    CommunicationAuthorization: 'COMMUNICATION_AUTHORIZATION'
} as const;
export type RegistrationPatchRequestConsentAcceptedEnum = typeof RegistrationPatchRequestConsentAcceptedEnum[keyof typeof RegistrationPatchRequestConsentAcceptedEnum];


/**
 * Check if a given object implements the RegistrationPatchRequest interface.
 */
export function instanceOfRegistrationPatchRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegistrationPatchRequestFromJSON(json: any): RegistrationPatchRequest {
    return RegistrationPatchRequestFromJSONTyped(json, false);
}

export function RegistrationPatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationPatchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'givenName': !exists(json, 'givenName') ? undefined : json['givenName'],
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'sponsor': !exists(json, 'sponsor') ? undefined : json['sponsor'],
        'doNotKnowSponsor': !exists(json, 'doNotKnowSponsor') ? undefined : json['doNotKnowSponsor'],
        'internationalSponsor': !exists(json, 'internationalSponsor') ? undefined : InternationalSponsorFromJSON(json['internationalSponsor']),
        'multipleBusinessFlag': !exists(json, 'multipleBusinessFlag') ? undefined : json['multipleBusinessFlag'],
        'extensions': !exists(json, 'extensions') ? undefined : json['extensions'],
        'partyId': !exists(json, 'partyId') ? undefined : json['partyId'],
        'personalId': !exists(json, 'personalId') ? undefined : PersonalIdFromJSON(json['personalId']),
        'personalIdList': !exists(json, 'personalIdList') ? undefined : ((json['personalIdList'] as Array<any>).map(PersonalIdFromJSON)),
        'taxRegime': !exists(json, 'taxRegime') ? undefined : json['taxRegime'],
        'spousePersonalId': !exists(json, 'spousePersonalId') ? undefined : PersonalIdFromJSON(json['spousePersonalId']),
        'consentAccepted': !exists(json, 'consentAccepted') ? undefined : json['consentAccepted'],
        'taxId': !exists(json, 'taxId') ? undefined : TaxIdFromJSON(json['taxId']),
        'billingAddress': !exists(json, 'billingAddress') ? undefined : ContactFromJSON(json['billingAddress']),
        'birthDate': !exists(json, 'birthDate') ? undefined : (new Date(json['birthDate'])),
        'gender': !exists(json, 'gender') ? undefined : GenderFromJSON(json['gender']),
        'isMinor': !exists(json, 'isMinor') ? undefined : json['isMinor'],
        'minorDocuments': !exists(json, 'minorDocuments') ? undefined : ((json['minorDocuments'] as Array<any>).map(MinorDocumentFromJSON)),
        'coAppDocuments': !exists(json, 'coAppDocuments') ? undefined : ((json['coAppDocuments'] as Array<any>).map(CoAppDocumentFromJSON)),
        'signature': !exists(json, 'signature') ? undefined : SignatureFromJSON(json['signature']),
        'citizenship': !exists(json, 'citizenship') ? undefined : CitizenshipFromJSON(json['citizenship']),
        'citizenshipCountry': !exists(json, 'citizenshipCountry') ? undefined : json['citizenshipCountry'],
        'spouseCitizenship': !exists(json, 'spouseCitizenship') ? undefined : CitizenshipFromJSON(json['spouseCitizenship']),
        'spouseCitizenshipCountry': !exists(json, 'spouseCitizenshipCountry') ? undefined : json['spouseCitizenshipCountry'],
        'maritalStatus': !exists(json, 'maritalStatus') ? undefined : MaritalStatusCdFromJSON(json['maritalStatus']),
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'accountNumber': !exists(json, 'accountNumber') ? undefined : json['accountNumber'],
        'verifyPersonalId': !exists(json, 'verifyPersonalId') ? undefined : json['verifyPersonalId'],
        'fullUrl': !exists(json, 'fullUrl') ? undefined : json['fullUrl'],
        'invitationLink': !exists(json, 'invitationLink') ? undefined : json['invitationLink'],
        'challengeId': !exists(json, 'challengeId') ? undefined : json['challengeId'],
        'prePrintedKitId': !exists(json, 'prePrintedKitId') ? undefined : json['prePrintedKitId'],
        'reservedAccountNumber': !exists(json, 'reservedAccountNumber') ? undefined : json['reservedAccountNumber'],
        'orderRequired': !exists(json, 'orderRequired') ? undefined : json['orderRequired'],
        'signInIdFlow': !exists(json, 'signInIdFlow') ? undefined : SignInIdFlowFromJSON(json['signInIdFlow']),
        'usernameContactType': !exists(json, 'usernameContactType') ? undefined : UsernameContactTypeFromJSON(json['usernameContactType']),
        'autoRenewalVerificationStatus': !exists(json, 'autoRenewalVerificationStatus') ? undefined : AutoRenewalVerificationStatusFromJSON(json['autoRenewalVerificationStatus']),
        'autoRenewalPaymentVerificationSubmitDateTime': !exists(json, 'autoRenewalPaymentVerificationSubmitDateTime') ? undefined : (new Date(json['autoRenewalPaymentVerificationSubmitDateTime'])),
        'autoRenewDetails': !exists(json, 'autoRenewDetails') ? undefined : AutoRenewSubmitDetailFromJSON(json['autoRenewDetails']),
        'employeeId': !exists(json, 'employeeId') ? undefined : json['employeeId'],
        'interimPhone': !exists(json, 'interimPhone') ? undefined : json['interimPhone'],
        'registeredAccountNumber': !exists(json, 'registeredAccountNumber') ? undefined : json['registeredAccountNumber'],
        'otpRequestId': !exists(json, 'otpRequestId') ? undefined : json['otpRequestId'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'identityJWT': !exists(json, 'identityJWT') ? undefined : json['identityJWT'],
    };
}

export function RegistrationPatchRequestToJSON(value?: RegistrationPatchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'givenName': value.givenName,
        'familyName': value.familyName,
        'sponsor': value.sponsor,
        'doNotKnowSponsor': value.doNotKnowSponsor,
        'internationalSponsor': InternationalSponsorToJSON(value.internationalSponsor),
        'multipleBusinessFlag': value.multipleBusinessFlag,
        'extensions': value.extensions,
        'partyId': value.partyId,
        'personalId': PersonalIdToJSON(value.personalId),
        'personalIdList': value.personalIdList === undefined ? undefined : ((value.personalIdList as Array<any>).map(PersonalIdToJSON)),
        'taxRegime': value.taxRegime,
        'spousePersonalId': PersonalIdToJSON(value.spousePersonalId),
        'consentAccepted': value.consentAccepted,
        'taxId': TaxIdToJSON(value.taxId),
        'billingAddress': ContactToJSON(value.billingAddress),
        'birthDate': value.birthDate === undefined ? undefined : (value.birthDate.toISOString().substring(0,10)),
        'gender': GenderToJSON(value.gender),
        'isMinor': value.isMinor,
        'minorDocuments': value.minorDocuments === undefined ? undefined : ((value.minorDocuments as Array<any>).map(MinorDocumentToJSON)),
        'coAppDocuments': value.coAppDocuments === undefined ? undefined : ((value.coAppDocuments as Array<any>).map(CoAppDocumentToJSON)),
        'signature': SignatureToJSON(value.signature),
        'citizenship': CitizenshipToJSON(value.citizenship),
        'citizenshipCountry': value.citizenshipCountry,
        'spouseCitizenship': CitizenshipToJSON(value.spouseCitizenship),
        'spouseCitizenshipCountry': value.spouseCitizenshipCountry,
        'maritalStatus': MaritalStatusCdToJSON(value.maritalStatus),
        'phone': value.phone,
        'email': value.email,
        'accountNumber': value.accountNumber,
        'verifyPersonalId': value.verifyPersonalId,
        'fullUrl': value.fullUrl,
        'invitationLink': value.invitationLink,
        'challengeId': value.challengeId,
        'prePrintedKitId': value.prePrintedKitId,
        'reservedAccountNumber': value.reservedAccountNumber,
        'orderRequired': value.orderRequired,
        'signInIdFlow': SignInIdFlowToJSON(value.signInIdFlow),
        'usernameContactType': UsernameContactTypeToJSON(value.usernameContactType),
        'autoRenewalVerificationStatus': AutoRenewalVerificationStatusToJSON(value.autoRenewalVerificationStatus),
        'autoRenewalPaymentVerificationSubmitDateTime': value.autoRenewalPaymentVerificationSubmitDateTime === undefined ? undefined : (value.autoRenewalPaymentVerificationSubmitDateTime.toISOString()),
        'autoRenewDetails': AutoRenewSubmitDetailToJSON(value.autoRenewDetails),
        'employeeId': value.employeeId,
        'interimPhone': value.interimPhone,
        'registeredAccountNumber': value.registeredAccountNumber,
        'otpRequestId': value.otpRequestId,
        'version': value.version,
        'identityJWT': value.identityJWT,
    };
}

